import { Dialog, DialogActions, DialogButton, DialogContent, DialogHeader } from '~/components/ui/Dialog';
import type { RepoFullName } from '~/types/github';

export function GithubConflictDialog({
  open,
  onClose,
  repo,
}: {
  open: boolean;
  onClose: (tryAgain: boolean) => void;
  repo: RepoFullName;
}) {
  return (
    <Dialog open={open} showCloseButton={false} maxWidth={600}>
      <DialogHeader title="GitHub conflict" badge="error" description="Unable to push your latest changes" />
      <DialogContent>
        <p className="mb-4">
          We were unable to push your latest changes to{' '}
          <span className="text-bolt-elements-textPrimary">
            {repo.owner}/{repo.name}
          </span>{' '}
          as the latest uploaded version is more recent. We need to pull this newer version before we can continue.
        </p>

        <p>Do you want to resend your latest message?</p>
      </DialogContent>

      <DialogActions orientation="vertical">
        <DialogButton onClick={() => onClose(true)}>Pull and resend last message</DialogButton>
        <DialogButton variant="secondary" onClick={() => onClose(false)}>
          Pull and discard last message
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
}
